module.exports = __webpack_public_path__ + "static/media/Pochette_humanité.0e9aeaa4.jpg";